import { useEffect, useRef, useState } from "react";

export default function useTimedRender(ms: number) {
    const ref = useRef(0);
    const [, forceUpdate] = useState({});

    useEffect(() => {
        forceUpdate({});
        ref.current++;

        const interval = setInterval(() => {
            forceUpdate({});
            ref.current++;
            //console.log(ref.current)
        }, ms);

        return () => clearInterval(interval);
    }, [ms]);

    return ref.current; 
}